const getSystemInfo = () => {
  var u = navigator.userAgent;
  var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // 是否为ios设备
  var isPC = typeof window.orientation === "undefined"; // 是否为PC端
  var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; // 是否为android端
  var isWx = u.toLocaleLowerCase().indexOf("micromessenger") > -1; // 判断是否为微信浏览器
  var isPhoneX =
    /iphone/gi.test(navigator.userAgent) &&
    screen.height >= 812 &&
    screen.width >= 375;
  var isLargeThan375 = screen.width > 375;
  var isLessThan360 = screen.width <= 360;
  const isNfPlus = /nfapp/i.test(navigator.userAgent);

  let os = {
    ios: isIOS,
    pc: isPC,
    android: isAndroid,
    isWx: isWx,
    isPhoneX: isPhoneX,
    isLargeThan375: isLargeThan375,
    isLessThan360: isLessThan360,
    isNfPlus: !!isNfPlus,
  };
  return os;
};

export default getSystemInfo;

// eslint-disable-next-line jsdoc/require-returns
/**
 * 判断是否是微信环境
 */
export function isInWechatMP() {
  return (
    (navigator.userAgent.match(/micromessenger/i) &&
      navigator.userAgent.match(/miniprogram/i)) ||
    window.__wxjs_environment === "miniprogram"
  );
}
